<template>
    <div class="product-panel">
        <div v-if="panelObj.mobile" class="panel_mobile_image">
            <a
                :class="[panelObj.link ? LinkClass : CannotLinkClass]"
                :href="panelObj.link"
                @click="openLink"
            >
                <img :src="panelObj.image"/>
            </a>
        </div>
        <div v-else class="panel_image">
            <a
                :class="[panelObj.link ? LinkClass : CannotLinkClass]"
                :href="panelObj.link"
                @click="openLink"
            >
                <img :src="panelObj.image"/>
            </a>
        </div>
        <div v-if="panelObj.title" class="panel_info">
            <ul class="panel_info-box">
                <li class="panel_title">{{ panelObj.title }}</li>
            </ul>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'Panel',
        props: {
            panelObj: {
                type: Object
            }
        },
        data() {
            return {
                LinkClass: 'link-page',
                CannotLinkClass: 'cannot-link-page'
            }
        },
        methods: {
            openLink(event) {
                if (this.panelObj.link?.startsWith('/')) {
                    event.preventDefault()
                    this.$router.push(this.panelObj.link)
                }
            }
        }
    }
</script>
